let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("hI5Pk"), load("dWaws"), load("hGDg2")]).then(() => parcelRequire('aBr88'));